import Card from "@mui/material/Card";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./finalisefs.css";
import swal from 'sweetalert';
import OutlinedInput from "@mui/material/OutlinedInput";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddFooters from "./footers";
import { motion } from "framer-motion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import standalonecss from "../../myfin_v2/css/standalone.module.css"
import { Button } from "../../myfin_v2/elements/Button";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusBlack.svg";
import { addConsolSignatoryApiHandler, deleteConsolSignatoryApiHandler, editConsolSignatoryApiHandler, consolFinalizeFSFormatApiHandler, getConsolePopulateFSExportFSApiHandler, getConsolFinalizeFSApiHandler } from "../../WorkSpace/Components/ApiServices/apiHandler";
import AddEditSignatory from "./AddEditSignatory";
import QuillReactEditor from "../../myfin_v2/components/QuillReactEditor";
import Signatory from "./Signatory";
import ExportPages from "./ExportPages";
// import "./finalisefs.css";
import sigCss from "../../myfin_v2/css/textEditor.module.css";
import addSignCard from "../../myfin_v2/assets/icons/addSignCard.png";
import cardHover from "../../myfin_v2/assets/icons/cardHover.png";
import Dropdown from "../../myfin_v2/elements/Dropdown";
import DeletePopup from "../../myfin_v2/elements/DeletePopup";
import Checkmark from "../../myfin_v2/assets/icons/Check(circle).png";

const FinaliseFsConsol = () => {

  const { consolID } = useParams();
  console.log("consolID", consolID);

  const units_values = [
    "whole numbers",
    "hundreds",
    "thousands",
    "lakhs",
    "crores",
    "millions",
    "billions"
  ];
  const decimal_values = [0, 1, 2, 3];

  const unitsOptions = units_values.map((val) => ({ label: val, value: val }));
  const decimalOptions = decimal_values.map((val) => ({ label: String(val), value: val }));
  const [removeNullFields, setRemoveNullFields] = useState(false);
  const [unit, setUnit] = useState("whole numbers");
  const [decimal, setDecimal] = useState(0);
 const [checkBoxList] = useState([
  { label: "Balance Sheet", value: "BS" },
  { label: "Profit & Loss", value: "PL" },
  { label: "Cashflow", value: "cashflow" },
  { label: "Cashflow Workings", value: "cashflow workings" },
  { label: "SOCIE", value: "socie" },
  { label: "Profit & Loss Notes", value: "PL notes" },
  { label: "Disclosure", value: "disclosure" },
  { label: "Disclosure Checklist", value: "disclosure checklist" },
  { label: "General Notes", value: "general notes" },
  { label: "Balance Sheet Notes", value: "BS notes" }
]);

const [isLoading, setIsLoading] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const workspace_data = useSelector((state) => state.WSReducer);
  const workspaceName = workspace_data?.response?.[0]?.workspace_name || sessionStorage.getItem("adj_workspace_name") || localStorage.getItem("workspaceName") || "Workspace";
  const workspaceID = workspace_data?.response?.[0]?._id || localStorage.getItem("ws_id") || "";
  const consolName = sessionStorage.getItem("adj_consol_name") || "Consol";

  const breadcrumbItems = [
    {
      label: workspaceName,
      link: workspaceID ? `/consolidation/${workspaceID}` : `/myfinV2/standalonefs`,
      className: "headerLable clickable",
    },
    {
      label: consolName,
      link: `/myfinV2/console-prepopulatefs/${consolID}`,
      className: "headerLable clickable",
    },
    {
      label: "Consol FS",
      link: `/myfinV2/console-populatefs/${consolID}`,
      className: "headerLable clickable",
    },
    { label: "Finalise FS", link: "", className: "headerLable" },
  ];

    const headerSections = [
      "Balance Sheet",
      "Statement of Profit & Loss",
      "Cashflow",
      "Statement of Change in Equity",
      "General Notes",
      "Balance Sheet Notes",
      "Profit & Loss Notes",
      "Disclosure",
    ];
  
    const [activeHeader, setActiveHeader] = useState("Balance Sheet");
    
    const footerSections = [
      "Balance Sheet",
      "Statement of Profit & Loss",
      "Cashflow",
      "Statement of Change in Equity",
      "General Notes",
      "Balance Sheet Notes",
      "Profit & Loss Notes",
      "Disclosure",
    ];
  
 const [activeFooter, setActiveFooter] = useState("Balance Sheet");
const createInitialSections = React.useCallback((sections) =>
  sections.reduce((acc, section) => {
    acc[section] = "";
    return acc;
  }, {}), []);

 const [headerContent, setHeaderContent] = useState( createInitialSections(headerSections));
 const [footerContent, setFooterContent] = useState( createInitialSections(footerSections));

  const [selectedFooters, setSelectedFooters] = useState([]);
  const [selectedExportPages, setSelectedExportPages] = useState([]);

  const [showAddEditSignatoryModal, setShowAddEditSignatoryModal] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [signatoryToDelete, setSignatoryToDelete] = useState(null);
  const [signatoryList, setSignatoryList] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleUnitDecimal = (e) => {
    if (e.target.name === "unit") {
      setUnit(e.target.value);
    } else {
      setDecimal(e.target.value);
    }
  };



  const exportFS = (exportAs) => {
    const params = {
      consolID: consolID,
      fileType: exportAs,
    };

    getConsolePopulateFSExportFSApiHandler(params)
      .then((response) => {
        const blob = new Blob(
          [response.data],
          {
            type:
              exportAs === "pdf"
                ? "application/pdf"
                : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

        const fileUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileUrl;

        downloadLink.download =
          exportAs === "pdf"
            ? `FS_${consolID}.pdf`
            : `FS_${consolID}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();

        downloadLink.remove();
        window.URL.revokeObjectURL(fileUrl);
      })
      .catch((error) => {
        console.error("exportFS error:", error);
      });
  };

  const [formData, setFormData] = useState({
    "_id": null,
    "category": null,
    "firmName": null,
    "firmRole": null,
    "firmNumber": null,
    "auditorName": null,
    "auditorRole": null,
    "membershipNumber": null,

    "directorName": null,
    "directorRole": null,
    "directorNumber": null,

    "place": null,
    "date": null
  })

  useEffect(() => {
  if (isInitialLoad) return;  

  const timeout = setTimeout(() => {
    handleFSFormat();
  }, 800); 

  return () => clearTimeout(timeout);
}, [
  headerContent,
  footerContent,
  unit,
  decimal,
  selectedFooters,
  selectedExportPages,
  removeNullFields
]);



 const getFinalizeFS = () => {
  getConsolFinalizeFSApiHandler(consolID)
    .then(response => {

      const finalizeFSFormat = response.data.finalizeFSFormat;
      const signatoryList = response.data.signatoryList;

      setUnit(finalizeFSFormat?.units ?? "whole numbers");
      setDecimal(finalizeFSFormat?.decimals ?? 0);
      setSelectedFooters(finalizeFSFormat?.addFooterTo ?? []);
      setSelectedExportPages(finalizeFSFormat?.exportPages ?? []);
      setRemoveNullFields(finalizeFSFormat?.removeNullField ?? false);
      setSignatoryList(signatoryList ?? []);
      setHeaderContent({
        "Balance Sheet": finalizeFSFormat?.BSHeader ?? "",
        "Statement of Profit & Loss": finalizeFSFormat?.PLHeader ?? "",
        "Balance Sheet Notes": finalizeFSFormat?.BSNotesHeader ?? "",
        "Profit & Loss Notes": finalizeFSFormat?.PLNotesHeader ?? "",
        "Cashflow": finalizeFSFormat?.cashflowHeader ?? "",
        "Statement of Change in Equity": finalizeFSFormat?.socieHeader ?? "",
        "Disclosure": finalizeFSFormat?.disclosureHeader ?? "",
        "General Notes": finalizeFSFormat?.generalNotesHeader ?? "",
      });

      setFooterContent({
        "Balance Sheet": finalizeFSFormat?.BSFooter ?? "",
        "Statement of Profit & Loss": finalizeFSFormat?.PLFooter ?? "",
        "Balance Sheet Notes": finalizeFSFormat?.BSNotesFooter ?? "",
        "Profit & Loss Notes": finalizeFSFormat?.PLNotesFooter ?? "",
        "Cashflow": finalizeFSFormat?.cashflowFooter ?? "",
        "Statement of Change in Equity": finalizeFSFormat?.socieFooter ?? "",
        "Disclosure": finalizeFSFormat?.disclosureFooter ?? "",
        "General Notes": finalizeFSFormat?.generalNotesFooter ?? "",
      });
      setIsInitialLoad(false);
      setIsLoading(false); 
    })
    .catch(error => {
      swal("Error", "Error: Get Finalize FS API Failed!", "error");
    });
};

const updateSelectedFooters = (items) => {
  setSelectedFooters(items);
 // handleFSFormat();   
};

const updateSelectedExportPages = (items) => {
  setSelectedExportPages(items);
 // handleFSFormat(); 
};

const handleFSFormat = () => {

  const finalizeFSFormat = {
    units: unit || "whole numbers",
    decimals: typeof decimal === "number" ? decimal : 0,
    exportPages: Array.isArray(selectedExportPages) ? selectedExportPages : [],
    addFooterTo: Array.isArray(selectedFooters) ? selectedFooters : [],
    removeNullField: Boolean(removeNullFields),
  };

  const addIfFilled = (key, value) => {
    if (value && value.trim() !== "") {
      finalizeFSFormat[key] = value;
    }
  };

  addIfFilled("BSHeader", headerContent["Balance Sheet"]);
  addIfFilled("PLHeader", headerContent["Statement of Profit & Loss"]);
  addIfFilled("BSNotesHeader", headerContent["Balance Sheet Notes"]);
  addIfFilled("PLNotesHeader", headerContent["Profit & Loss Notes"]);
  addIfFilled("cashflowHeader", headerContent["Cashflow"]);
  addIfFilled("socieHeader", headerContent["Statement of Change in Equity"]);
  addIfFilled("disclosureHeader", headerContent["Disclosure"]);
  addIfFilled("generalNotesHeader", headerContent["General Notes"]);
 
  addIfFilled("BSFooter", footerContent["Balance Sheet"]);
  addIfFilled("PLFooter", footerContent["Statement of Profit & Loss"]);
  addIfFilled("BSNotesFooter", footerContent["Balance Sheet Notes"]);
  addIfFilled("PLNotesFooter", footerContent["Profit & Loss Notes"]);
  addIfFilled("cashflowFooter", footerContent["Cashflow"]);
  addIfFilled("socieFooter", footerContent["Statement of Change in Equity"]);
  addIfFilled("disclosureFooter", footerContent["Disclosure"]);
  addIfFilled("generalNotesFooter", footerContent["General Notes"]);

  consolFinalizeFSFormatApiHandler(
    { consolID: consolID },
    { finalizeFSFormat }
  )
    .then((response) => {
      if (!response?.data?.success) {
        swal(
          "Error",
          response?.data?.error || "Unable to update Finalise FS format",
          "error"
        );
      }
    })
    .catch((error) => {
      swal(
        "Error",
        error?.response?.data?.error || "Unable to update Finalise FS format",
        "error"
      );
    });
};

useEffect(() => {
  getFinalizeFS();
}, []);

  useEffect(() => {
    if (showAddEditSignatoryModal === false) {
      setFormData({
        "_id": null,
        "category": null,
        "firmName": null,
        "firmRole": null,
        "firmNumber": null,
        "auditorName": null,
        "auditorRole": null,
        "membershipNumber": null,

        "directorName": null,
        "directorRole": null,
        "directorNumber": null,

        "place": null,
        "date": null
      })
    }
  }, [showAddEditSignatoryModal])


  const handleSaveAuditor = (formData) => {

    const payload = {
      category: formData.category,
      place: formData.place,
      date: formData.date,

      ...(formData.category === "auditor" && {
        firmName: formData.firmName,
        firmRole: formData.firmRole,
        firmNumber: formData.firmNumber,
        auditorName: formData.auditorName,
        auditorRole: formData.auditorRole,
        membershipNumber: formData.membershipNumber,
      }),

      ...(formData.category === "board of directors" && {
        directorName: formData.directorName,
        directorRole: formData.directorRole,
        directorNumber: formData.directorNumber,
      }),
    };

    if (formData?._id) {
      saveModifiedSignatoryHandler(payload, formData?._id);
    } else {
      addSignatoryHandler(payload);
    }

  }

  const addSignatoryHandler = (payload) => {

    addConsolSignatoryApiHandler({ consolID: consolID }, payload)
      .then((response) => {
        console.log("response", response);

        if (response?.data?.success === true) {
          setShowAddEditSignatoryModal(false);
          swal("Signatory added successful", "", "success");
          getFinalizeFS();
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to add Signatory",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to add Signatory",
          "error"
        );
      });
  }

  const saveModifiedSignatoryHandler = (payload, signId) => {

    editConsolSignatoryApiHandler({ consolID: consolID, signatoryID: signId }, payload)
      .then((response) => {
        console.log("response", response);

        if (response?.data?.success === true) {
          setShowAddEditSignatoryModal(false);
          swal("Signatory updated successful", "", "success");
          getFinalizeFS();
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update Signatory",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to update Signatory",
          "error"
        );
      });
  }

  const handleDeleteSignatory = (signId) => {
    setSignatoryToDelete(signId);
    setIsDeletePopupOpen(true);
  };

  const confirmDeleteSignatory = () => {
    if (!signatoryToDelete) return;
    deleteConsolSignatoryApiHandler({ consolID: consolID, signatoryID: signatoryToDelete })
      .then((response) => {
        if (response?.data?.success === true) {
          getFinalizeFS();
          setSuccessMessage("Signatory deleted successfully");
          setShowSuccessPopup(true);
          setTimeout(() => {
            setShowSuccessPopup(false);
          }, 2000);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsDeletePopupOpen(false);
        setSignatoryToDelete(null);
      });
  }


  const editSignatory = (signId) => {
    const modifySignatory = signatoryList.find((sign) => sign._id === signId)
    console.log("modifySignatory", modifySignatory);

    setFormData({
      "_id": modifySignatory?._id ?? null,
      "category": modifySignatory?.category ?? null,
      "firmName": modifySignatory?.firmName ?? null,
      "firmRole": modifySignatory?.firmRole ?? null,
      "firmNumber": modifySignatory?.firmNumber ?? null,
      "auditorName": modifySignatory?.auditorName ?? null,
      "auditorRole": modifySignatory?.auditorRole ?? null,
      "membershipNumber": modifySignatory?.membershipNumber ?? null,

      "directorName": modifySignatory?.directorName ?? null,
      "directorRole": modifySignatory?.directorRole ?? null,
      "directorNumber": modifySignatory?.directorNumber ?? null,

      "place": modifySignatory?.place ?? null,
      "date": modifySignatory?.date ?? null
    })
    setShowAddEditSignatoryModal(true);
  }

  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ maxHeight: "95vh", overflowY: "hidden" }} >
            {/* <BookcluosureNav bookClosureId={bookClosureId} setCreatePackageModal={setCreatePackageModal} setSavePresetModal={setSavePresetModal} selectedEntries={selectedEntries} entries={entries} /> */}
            <div className="fscp-header" style={{ padding: "15px 20px" }}>
              <Breadcrumb style="margin-right:auto"
                addCls={"bgTransprent"}
                p0={true}
                items={breadcrumbItems}
                headerActions={<></>}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as Excel"
                onClick={() => { exportFS("excel") }}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as PDF"
                onClick={() => { exportFS("pdf") }}
              />
            </div>

            <div className="mx-3">
              <div className={standalonecss.finaliseFSDiv}
              >
                <div className="d-flex mt-4 ml-3" style={{ gap: "20px", justifyContent: "space-between", alignItems: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "210px",
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel
                        id="unit-value-select-label"
                        shrink={unit !== null && unit !== undefined && unit !== ""}
                        sx={{
                          "&.Mui-focused": { color: "#B3C0BD" },
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#B3C0BD",
                          top: "-5px"
                        }}
                      >
                        {/* Units */}
                      </InputLabel>

                      <Dropdown
                        class_="finalisefs_dropdown"
                        placeHolder="Select Units"
                        options={unitsOptions}
                        searchable={true}
                        selValue={unit}
                        onSelect={(item) => handleUnitDecimal({ target: { name: "unit", value: item.value } })}
                        style2={{
                          borderRadius: "6px",
                          height: "32px",
                          width: "300px",
                          backgroundColor: "#F4FAF5",
                          padding: "0 10px"
                        }}
                      />
                    </FormControl>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "250px",
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel
                          id="decimal-value-select-label"
                          shrink={decimal !== null && decimal !== undefined && decimal !== ""}
                          sx={{
                            "&.Mui-focused": { color: "#B3C0BD" },
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#B3C0BD",
                            top: "-5px"
                          }}
                        >
                          {/* Decimals */}
                        </InputLabel>

                        <Dropdown
                          class_="finalisefs_dropdown"
                          placeHolder="Select Decimals"
                          options={decimalOptions}
                          searchable={true}
                          selValue={decimal}
                          onSelect={(item) => handleUnitDecimal({ target: { name: "decimal", value: item.value } })}
                          style2={{
                            borderRadius: "6px",
                            height: "32px",
                            width: "300px",
                            backgroundColor: "#F4FAF5",
                            padding: "0 10px"
                          }}
                        />
                      </FormControl>

                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      paddingRight: "30px",
                      cursor: "pointer",
                      marginLeft: "auto",
                    }}
                    onClick={() => setRemoveNullFields(!removeNullFields)}
                  >
                    <div
                      style={{
                        width: "34px",
                        height: "16px",
                        borderRadius: "20px",
                        backgroundColor: removeNullFields ? "#2D8861" : "#CCD5D3",
                        position: "relative",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "50%",
                          backgroundColor: "white",
                          position: "absolute",
                          top: "0px",
                          left: removeNullFields ? "18px" : "0px",
                          transition: "all 0.3s ease",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#205A46",
                      }}
                    >
                      Remove Null Fields
                    </span>

                  </div>
                </div>

                <div className="p-3">
                   <Card className="pb-10" style={{ borderRadius: "10px", border: "1px solid #CCD5D3", marginBottom: "20px"}}>
                <div className={standalonecss.finaliseFSSecHeader}>
                  <span  style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>
                    HEADER
                  </span>
                </div>

                <div className={sigCss.headerWrapper}>
                  
                  <div className={sigCss.leftHeaderContainer}>
                    {headerSections.map((item) => (
                      <div
                        key={item}
                        onClick={() => {
                         // handleFSFormat();  
                          setActiveHeader(item);
                        }}
                        className={`${sigCss.headerItem} ${
                          activeHeader === item ? sigCss.activeHeaderItem : ""
                        }`}
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                 <div
                className={sigCss.rightHeaderEditor}
              >
                <div style={{ flex: 1 }}>
                  <QuillReactEditor
                    key={activeHeader}
                    greyToolbar={true}
                    value={headerContent[activeHeader] || ""}
                    onChange={(data) => {
                      const html = data.html;

                      setHeaderContent(prev => {
                        if (prev[activeHeader] === html) return prev;
                        return { ...prev, [activeHeader]: html };
                      });
                    }}
                  />

                </div>
              </div>
             </div>
            </Card>

          <Card className="pb-2" style={{ borderRadius: "10px",  border: "1px solid #CCD5D3", marginBottom: "20px"}} >
            <div className={standalonecss.finaliseFSSecHeader}>
              <span  style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>FOOTER</span>
            </div>

              <div className={sigCss.headerWrapper}>
                <div className={sigCss.leftHeaderContainer}>
                  {footerSections.map((item) => (
                    <div
                      key={item}
                       onClick={() => {
                          // handleFSFormat();  
                          setActiveFooter(item);
                        }}
                      className={`${sigCss.headerItem} ${
                        activeFooter === item ? sigCss.activeHeaderItem : ""
                      }`}
                    >
                      {item}
                    </div>
                  ))}
                </div>

                <div
                  className={sigCss.rightHeaderEditor} >
                  <QuillReactEditor
                   key={activeFooter}
                    greyToolbar={true}
                    value={footerContent[activeFooter] || ""}
                    onChange={(data) => {
                      const html = data.html;

                      setFooterContent(prev => {
                        if (prev[activeFooter] === html) return prev;
                        return { ...prev, [activeFooter]: html };
                      });
                    }}
                  />
                </div>

              </div>
            </Card>
                  <Card className="pb-2" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}
                    >
                      <span  style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>SIGNATORY</span>
                    </div>
                    <AddFooters
                      checkBoxList={checkBoxList}
                      selectedItems={selectedFooters}
                      setSelectedItems={updateSelectedFooters}
                      setShowAddEditSignatoryModal={setShowAddEditSignatoryModal}
                    />
                    {/* <div className={`${commoncss.clickable} ml-3 my-2`} style={{ borderRadius: "6px", border: "1px solid #A0DABC"}} onClick={() => { setShowAddEditSignatoryModal(true) }}>
                      <PlusIcon height={18} width={18} /> &nbsp;<span className={`${commoncss.textLabel} ${commoncss.fs15}`}>Add Signatory</span>
                    </div> */}
                    <div style={{ display: "grid",  gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "30px",  padding: "20px" }}
                    // style={{ "height": "42vh", "overflow": "auto" }}
                    >
                      {signatoryList.map((signatory) => (
                        <>
                          <Signatory key={signatory._id} signatory={signatory} editSignatory={editSignatory} handleDeleteSignatory={handleDeleteSignatory} />
                        </>
                      ))}
                    <div onClick={() => setShowAddEditSignatoryModal(true)} className={sigCss.addSignatoryCard} style={{
                                              "--icon-normal": `url(${addSignCard})`,
                                              "--icon-hover": `url(${cardHover})`,}} >
                      Add New <br /> Signatory
                    </div>
                    </div>
                    {/* <div className={`${commoncss.clickable} ml-3 my-2`} onClick={() => { setShowAddEditSignatoryModal(true) }}>
                      <PlusIcon height={18} width={18} /> &nbsp;<span className={`${commoncss.textLabel} ${commoncss.fs15}`}>Add Signatory</span>
                    </div> */}
                  </Card>

                  <Card className="pb-2 mt-3" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}
                    >
                      
                      <span  style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>EXPORT PAGES</span>
                    </div>
                    <ExportPages
                      checkBoxList={checkBoxList}
                      selectedItems={selectedExportPages}
                      setSelectedItems={updateSelectedExportPages}
                    />
                  </Card>
                </div>
              </div>
            </div>
            {showAddEditSignatoryModal && <AddEditSignatory setShowAddEditSignatoryModal={setShowAddEditSignatoryModal} formData={formData} setFormData={setFormData} onSave={handleSaveAuditor} />}
            <DeletePopup 
              isOpen={isDeletePopupOpen}
              title="Confirm deletion of Signatory"
              message="Once deleted, you will not be able to recover this!"
              onConfirm={confirmDeleteSignatory}
              onCancel={() => {
                setIsDeletePopupOpen(false);
                setSignatoryToDelete(null);
              }}
            />
            {showSuccessPopup && (
              <div className={commoncss.overlay} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999 }}>
                <div className={commoncss.popup} style={{ width: "380px", height: "245px"}}>
                  <div className={commoncss.iconWrapper} >
                    <img src={Checkmark} alt="Success" width={90} height={90} />
                  </div>
                  <p className={commoncss.restoreText}>{successMessage}</p>
                </div>
              </div>
            )}
          </motion.div>
        </div >
      </div >
    </>
  );
};

export default FinaliseFsConsol;
